// Badge colors: completed = success, in_progress = warning, pending = secondary
export const STATUS_BADGE_COLOR = {
  completed: 'success',
  in_progress: 'warning',
  pending: 'secondary',
}

export const STATUS_LABEL = {
  completed: 'Completed',
  in_progress: 'In Progress',
  pending: 'Pending',
}

export const STEP_ICON = {
  about_game: 'cilInfo',
  game_structure: 'cilSitemap',
  rounds: 'cilCalendar',
  competitions: 'cilStar',
  teams: 'cilPeople',
  players: 'cilUser',
  fixtures: 'cilCalendarCheck',
  point_system: 'cilChartLine',
  game_entry: 'cilDoor',
  pricing_plan: 'cilDollar',
}
